module.exports = __webpack_public_path__ + "img/postcard-onboarding-example@2x.8d2e8cdf.png";